import {CabObj} from './index.js';

export enum AvailabilityState {
    closed,
    read,
    write,
}

export enum StatusEnum {
    future = 1,
    open,
    overdue,
    submitted,
    accepted,
    rejected
}

export enum PeriodEnum {
    Q = 1,
    H,
}

export enum OnderwerpEnum {
    mijlpaal = 1,
    adherentie,
    financien,
    personeel,
    productiviteit,
    quadrupleAim,
    toegankelijkheid,
    volumes,
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    proces   = 1, // extra alias
}

export enum KPITypeEnum {
    input = 1,
    output,
    onderliggend,
}

export enum PrognoseSchaalEnum {
    none = 1,
    once,
    all,
}

export enum WaardeTypeEnum {
    getal = 1,
    percentage,
    bedrag,
    decimaal,
}

export enum MijlpaalEnum {
    gehaald = 1,
    gemist,
    onbekend,
    gestart,
}

export enum KpiStatusEnum {
    gehaald = 1,
    gemist,
    onbekend
}

export enum MijlpaalPrognoseEnum {
    wordtGehaald = 1,
    kansOpMissen,
    wordtGemist
}

export enum KpiStatusPrognoseEnum {
    wordtGehaald = 1,
    kansOpMissen,
    wordtGemist
}

export enum WachttijdApiTypeEnum {
    MSZ = 1,
    GGZ,
}

export enum UnavailabilityReasonEnum {
    insufficientObservations = 1,
    aanmeldstop,
    unknown,
}

// the dashboard series a kpi can feed, see common/dashboard.ts
export enum DashboardReeksEnum {
    maxFormatie             = 'maxFormatie',
    wachttijdenTreeknorm    = 'wachttijdenTreeknorm',
    adherentie              = 'adherentie',
    verwijzingenMsz         = 'verwijzingenMsz',
    verwijzingenGgz         = 'verwijzingenGgz',
    noni                    = 'noni',
    volume                  = 'volume',
    productiviteit          = 'productiviteit',
    omzet                   = 'omzet',
    schadelast              = 'schadelast',
    medewerkerstevredenheid = 'medewerkerstevredenheid',
    klanttevredenheid       = 'klanttevredenheid',
}

export enum DashboardTargetRuleEnum {
    groeiTovEersteMeting    = 'groeiTovEersteMeting',
    minimaalGelijkVorigJaar = 'minimaalGelijkVorigJaar',
    vasteWaarde             = 'vasteWaarde',
}

// design spec 7.4; the order matters for teruggezet detection
export enum InitiatiefFaseEnum {
    initiatief = 'initiatief',
    orientatie = 'orientatie',
    realisatie = 'realisatie',
    afronding  = 'afronding',
    afgerond   = 'afgerond',
    onbekend   = 'onbekend',
}

export enum FteTargetMetricEnum {
    geidentificeerd = 'geidentificeerd',
    gemeten         = 'gemeten',
    maxFormatie     = 'maxFormatie',
}

export enum FinancieleCategorieEnum {
    beschikbaar = 'beschikbaar',
    realisatie  = 'realisatie',
    prognose    = 'prognose',
}

export type TreekNormCategory = 'Diagnostiek' | 'Polikliniekbezoek' | 'Behandeling' | 'GGZ_AanmeldGesprek' | 'GGZ_Behandeling';

export const SELECTOR_STARTS_WITH = '⬅';
export const SELECTOR_ENDS_WITH   = '➡';
export const SELECTOR_CONTAINS    = '↔';
export const SELECTOR_REGEXP      = '®';
export const SELECTOR_IS_NOT_NULL = '∃';

export enum Role {
    admin            = 'admin',
    reporter         = 'reporter',
    super_reporter   = 'super_reporter',
    acceptant        = 'acceptant',
    reporter_manager = 'reporter_manager',
    exporter         = 'exporter',
    dashboard_viewer = 'dashboard_viewer'
}

export enum Permission {
    admin            = 'admin',
    report           = 'report',
    api              = 'api',
    accept           = 'accept',
    export           = 'export',
    manage_reporters = 'manage_reporters',
    dashboard        = 'dashboard'
}

export enum CrudAction {
    list   = 'list',
    create = 'create',
    update = 'update',
    delete = 'delete'
}

export type Selector = { [p: string]: SelectorValue; };
export type SelectorValue = string | string[] | number | number[] | CabObj | CabObj[] | boolean;

//////////////////////////////////// kpi dependency graph ////////////////////////////////////

export type KpiExpressionField = 'waardeExpression' | 'gehaaldExpression';

export enum KpiGraphUnresolvedReason {
    nietGevonden = 'nietGevonden', // no kpi with this name or korte naam
    nietUniek    = 'nietUniek',    // more than one kpi matches this name or korte naam
    mijlpaal     = 'mijlpaal',     // the reference resolves to a mijlpaal, which has no report items
    dynamisch    = 'dynamisch',    // the kpi name is an expression, only known at evaluation time
}

export interface KpiGraphNode {
    uuid: string;
    name: string;
    korteNaam?: string;
}

export interface KpiGraphEdge {
    from: string; // uuid of the kpi whose expression references the kpi with uuid 'to'
    to: string;
    field: KpiExpressionField;
}

export interface KpiGraphUnresolved {
    from: string; // uuid of the kpi whose expression contains the reference
    field: KpiExpressionField;
    ref?: string; // undefined for dynamic references
    reason: KpiGraphUnresolvedReason;
}

export interface KpiGraph {
    nodes: KpiGraphNode[];
    edges: KpiGraphEdge[];
    unresolved: KpiGraphUnresolved[];
    cycles: string[][]; // each cycle as a list of node uuids
}